import React from 'react';

interface Props {
  height: number;
  value: string;
}

// TODO: Ideally we'd provide the label to the Axis component and render it via
// svg text; however, the effort required to properly implement that is higher
// than we're willing to take on at this time. Alternatively, we could also
// reach for a chart library - here is a ticket we have to assess our options:
// https://github.com/mdg-private/planning/issues/1241
export function YAxisLabel({ height, value }: Props) {
  return (
    <div
      className="max-w-[30px] text-center text-xs text-secondary"
      style={{ writingMode: 'vertical-rl', height }}
    >
      {value}
    </div>
  );
}
